module.exports = __webpack_public_path__ + "static/media/image8.283876f9.png";